export default {
	"Publicity.ShopAnnouncements": "店鋪公告",
	"Publicity.MarketingMallComponentClick": "行銷商城_元件點擊",
	"Publicity.MarketingMarketplace": "行銷商城"
}